import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const getKybs = ({ queryKey }) => {
  return http.get("/kyb", { params: { ...queryKey[1] } });
};

const getKybOrgSummary = ({ queryKey }) => {
  return http.get("/kyb/org-summary", { params: { ...queryKey[1] } });
};

const getKybById = ({ queryKey }) => {
  return http.get(`/kyb/${queryKey[1]?.id}`, { params: { ...queryKey[1] } });
};

const createKyb = (data: any) => {
  return http.post("/kyb", data);
};

const updateKyb = ({ id, ...data }: any) => {
  return http.put(`/kyb/${id}`, data);
};

const deleteKyb = (id: number) => {
  return http.delete(`/kyb/${id}`);
};

const deleteBulkKyb = ({ body }: { body?: any }) => {
  return http.post("/kyb/bulk-delete", { data: body });
};

const exportKybReport = (data: any) => {
  return cronHttp.post("/kyb/export", data);
};

export {
  createKyb,
  getKybs,
  getKybById,
  getKybOrgSummary,
  updateKyb,
  deleteKyb,
  deleteBulkKyb,
  exportKybReport,
};